import React, {useState, useEffect} from "react";
import {get, useForm} from "react-hook-form";
import {
    PageWrapper,
    RTEWrapper
} from "BaseComponents/Wrappers";
import {
    Input,
    RichInput,
    CheckBoxStyle,
    CheckboxWrapper,
    CheckBoxLabel,
} from "BaseComponents/Form";
import {useGlobal} from "reactn";
import {FormWrapper, Spinner, Wrapper, FormField, Label, ErrorField, ErrorText} from "Blocks";
import styled from "styled-components";
import {getButtonColor} from "Helpers/ColorHelper";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {post} from "Helpers/ApiHelper";
import {ButtonText, PrimaryButton, PrimarySubmitButton} from "BaseComponents/Button";
import {Header, OuterHeroTextWrapper, HeroTextWrapper} from "Components/HeroText";
import {ErrorMessage} from "@hookform/error-message";

let RenderReportTechnicalUrlPage = ({
                                        Alias,
                                        Heading,
                                        CloseLabel,
                                        CloseButtonLink,
                                        EmailAddresss,
                                        EmailFeedbackLabel,
                                        FeedbackLabel,
                                        HeadingBackgroundColor,
                                        InformationText,
                                        MessageLabel,
                                        PageBackgroundColor,
                                        SendLabel,
                                        SuccessMessage,
                                        SuccessMessageBackgroundColor,
                                        TechnicalIssueUrlLabel,
                                        EmailErrorText,
                                        RequiredText,
                                        FormErrorText,
                                        FormErrorMinLengthText
                                    }) => {

    const {
        handleSubmit,
        register,
        errors,
        unregister,
        watch,
        setValue
    } = useForm({
        mode: "all",
        defaultValues: {
            url: '',
            message: '',
            feedback: false,
            email: ''
        }
    });

    const feedbackWatch = watch(FeedbackLabel);

    useEffect(() => {
        if (feedbackWatch) {
            register(EmailFeedbackLabel);
        } else {
            unregister(EmailFeedbackLabel);
        }
    }, [register, unregister, feedbackWatch]);

    const [theme] = useGlobal("theme");
    const [loading, setLoading] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [text, setText] = useState(SuccessMessage);

    let bgInnerColor, bgInnerTextColor, bgInnerPageColor, bgInnerTextPageColor, bgInnerMessageColor,
        bgInnerTextMessageColor = undefined;
    if (HeadingBackgroundColor) {
        const {color: bgColor, textColor: bgTextColor} = getButtonColor(HeadingBackgroundColor);
        bgInnerColor = bgColor;
        bgInnerTextColor = bgTextColor;
    }
    if (PageBackgroundColor) {
        const {color: bgPageColor, textColor: bgTextPageColor} = getButtonColor(PageBackgroundColor);
        bgInnerPageColor = bgPageColor;
        bgInnerTextPageColor = bgTextPageColor;
    }
    if (SuccessMessageBackgroundColor) {
        const {color: bgMessageColor, textColor: bgTextMessageColor} = getButtonColor(SuccessMessageBackgroundColor);
        bgInnerMessageColor = bgMessageColor;
        bgInnerTextMessageColor = bgTextMessageColor;
    }
    const onSubmit = (values, e) => {
        setLoading(true);
        const targetUrl = `/umbraco/api/send_report_email`;
        let result = Object.keys(values).map((key, i) => {
            let sendValue;
            if (typeof values[key] === "object") {
                sendValue = _.pickBy(values[key], (value, key) => {
                    return value;
                });
                if (_.isEmpty(sendValue)) {
                    return;
                }
                if (typeof sendValue === "boolean") {
                    sendValue = sendValue ? undefined : "";
                }
                if (typeof sendValue === "object") {
                    let newI = {};
                    Object.keys(sendValue).map((item) => {
                        if (typeof sendValue[item] === "boolean") {
                            newI[item] = "";
                        } else {
                            newI[item] = sendValue[item];
                        }
                    });
                    sendValue = newI;
                }
            } else if (typeof values[key] === "boolean") {
                if (values[key] === false) {
                    return;
                }
                sendValue = "";
            } else {
                sendValue = values[key];
            }
            return {key: key, value: sendValue};
        });

        const labelsPosition = [TechnicalIssueUrlLabel, MessageLabel, FeedbackLabel, EmailFeedbackLabel];
        result = _.reject(result, _.isUndefined).sort(
            (a, b) => labelsPosition.indexOf(a.key) - labelsPosition.indexOf(b.key)
        );

        const json = {
            result: result,
            subject: "Report technical issue",
            recipient: EmailAddresss,
        };

        post(json, targetUrl).then((res) => {
            if (!res.isSuccessStatusCode) setText(FormErrorText);
            setLoading(false);
            setToggle(true);
        });
    };

    const minLenthMessageError = FormErrorMinLengthText?.replace(
        "{VALUE}",
        3
    );
    const registerOptions = {
        message: {required: RequiredText, minLength: {value: 3, message: minLenthMessageError}},
        email: {
            required: RequiredText,
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i,
                message: EmailErrorText,
            }
        },
    };

    const errorMessage = get(errors, MessageLabel) != undefined;
    const errorEmail = get(errors, EmailFeedbackLabel) != undefined;

    return (
        <>
            <div className={`${Alias}`}>
                <ReportHeroWrapper bgColor={bgInnerColor}>
                    <OuterHeroTextWrapper height="100%" showBlock={true} mobilePadding={"0rem 4rem 0rem 2rem"}
                                          ipadPadding={"0rem 4rem 0rem 2rem"}>
                        <HeroTextWrapper height="100%" alignItems={"center"}>
                            <Header color={bgInnerTextColor ? bgInnerTextColor : 'black'}>
                                {Heading}
                            </Header>
                        </HeroTextWrapper>
                    </OuterHeroTextWrapper>
                </ReportHeroWrapper>
                <ReportPageWrapper bgColor={bgInnerPageColor}>
                    {loading && <Spinner/>}
                    <ReportBlockContainer>
                        <ReportLeftWrapper>
                            <RTEWrapper
                                color={bgInnerTextPageColor}
                                dangerouslySetInnerHTML={{
                                    __html: InformationText,
                                }}
                            ></RTEWrapper>
                        </ReportLeftWrapper>
                        {!loading && <ReportRightWrapper>
                            <FormWrapper>
                                {!toggle ? (
                                    <ReportFieldForm onSubmit={handleSubmit(onSubmit)}
                                                     className={"reportFiledForm"}>
                                        <ReportFieldDiv gap={"1rem"}>
                                            <FormField>
                                                <Label htmlFor={TechnicalIssueUrlLabel}>
                                                    {TechnicalIssueUrlLabel}
                                                </Label>
                                                <Input
                                                    {...register(TechnicalIssueUrlLabel)}
                                                    onChange={(e) => {
                                                        setValue(TechnicalIssueUrlLabel, e.target.value);
                                                    }}
                                                    onBlur={(e) => {
                                                        setValue(TechnicalIssueUrlLabel, e.target.value);
                                                    }}

                                                />

                                            </FormField>

                                            <FormField error={errorMessage}>
                                                <ErrorField>
                                                    <Label htmlFor={MessageLabel} error={errorMessage}>
                                                        {MessageLabel} *
                                                    </Label>

                                                    <RichInput height="120px"
                                                               onChange={(e) => {
                                                                   setValue(MessageLabel, e.target.value, {shouldValidate: false});
                                                               }}
                                                               onBlur={(e) => {
                                                                   setValue(MessageLabel, e.target.value, {shouldValidate: false});
                                                               }}
                                                               {...register(MessageLabel, registerOptions.message)}></RichInput>
                                                    <ErrorText
                                                        margin={"0"}
                                                        bottom={"-20px"}
                                                        error={errorMessage}
                                                    >
                                                        <ErrorMessage errors={errors}
                                                                      name={MessageLabel}/>
                                                    </ErrorText>
                                                </ErrorField>

                                            </FormField>
                                            <FormField row={true}
                                                       center={true}
                                                       smallRow={true}>
                                                <CheckboxWrapper className={"checkboxWrapper"}>
                                                    <CheckBoxStyle
                                                        className={"checkboxStyle"}
                                                        tabIndex="0"
                                                        type="checkbox"
                                                        id={FeedbackLabel}
                                                        name={FeedbackLabel}
                                                        key={FeedbackLabel}
                                                        {...register(FeedbackLabel)}
                                                        markerColor={PageBackgroundColor}
                                                        onClick={(e) => {
                                                            setValue(FeedbackLabel, e.target.checked);
                                                        }}
                                                    ></CheckBoxStyle>
                                                    <CheckBoxLabel tabIndex="0" className={"checkBoxLabel"}
                                                                   htmlFor={FeedbackLabel}>{FeedbackLabel}</CheckBoxLabel>
                                                </CheckboxWrapper>
                                            </FormField>
                                            {feedbackWatch ? <FormField error={errorEmail}>
                                                <ErrorField>
                                                    <Label htmlFor={EmailFeedbackLabel} error={errorEmail}>
                                                        {EmailFeedbackLabel} *
                                                    </Label>
                                                    <Input
                                                        className={"emailinput"}
                                                        onChange={(e) => {
                                                            setValue(EmailFeedbackLabel, e.target.value, {shouldValidate: false});
                                                        }}
                                                        onBlur={(e) => {
                                                            setValue(EmailFeedbackLabel, e.target.value, {shouldValidate: false});
                                                        }}
                                                        {...register(EmailFeedbackLabel, registerOptions.email)}></Input>
                                                    <ErrorText
                                                        margin={"0"}
                                                        bottom={"-20px"}
                                                        error={errorEmail}
                                                    >
                                                        <ErrorMessage errors={errors}
                                                                      name={EmailFeedbackLabel}/>
                                                    </ErrorText>
                                                </ErrorField>
                                            </FormField> : null}
                                        </ReportFieldDiv>
                                        <Wrapper padding={"0"}>
                                            <PrimarySubmitButton
                                                type="submit"
                                                margin={"0"}
                                                marginsmall={"0"}
                                                alignself={"end"}
                                                width={"180px"}
                                                widthsmall={"180px"}
                                            >
                                                <ButtonText heading={Heading}>{SendLabel}</ButtonText>
                                            </PrimarySubmitButton>
                                        </Wrapper>
                                    </ReportFieldForm>
                                ) : (
                                    <ReportMessageWrapper bgColor={bgInnerMessageColor}>
                                        <RTEWrapper
                                            color={bgInnerTextMessageColor}
                                            dangerouslySetInnerHTML={{
                                                __html: text,
                                            }}
                                        ></RTEWrapper>
                                        <PrimaryButton
                                            justifycontent="center"
                                            alignself={"end"}
                                            display="flex"
                                            margin="0"
                                            href={CloseButtonLink?.Url ? CloseButtonLink?.Url : "/"}
                                            target={CloseButtonLink?.Target ?? "_self"}
                                            ariaLabel={Heading}
                                        >
                                            <ButtonText heading={CloseLabel}>{CloseLabel}</ButtonText>
                                        </PrimaryButton>
                                    </ReportMessageWrapper>
                                )}
                            </FormWrapper>
                        </ReportRightWrapper>}
                    </ReportBlockContainer>
                </ReportPageWrapper>
            </div>
        </>
    )
        
};
const ReportHeroWrapper = styled.div`
  background-color: ${
          ({theme, bgColor}) =>
                  bgColor ? bgColor : "white"
  };
  height: 182px;
  ${
          media.lessThan(breakpoints.mobile)`
    height: 120px;
  `
  }
`;

const ReportMessageWrapper = styled.div`
  background-color: ${
          ({theme, bgColor}) =>
                  bgColor ? bgColor : "white"
  };
  padding: 1.5rem 2.5rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 2rem;

`;
const ReportPageWrapper = styled.div`
  background-color: ${
          ({theme, bgColor}) =>
                  bgColor ? bgColor : "white"
  };
  padding-top: 3rem;
  padding-bottom: 5rem;
`;
const ReportLeftWrapper = styled.div`
  max-width: 402px;

  h1, h2, h3, h4 {
    margin: 0;
  }
`;
const ReportRightWrapper = styled.div`
  flex: 1;

  h1, h2, h3, h4 {
    margin: 0;
  }
`;

const ReportBlockContainer = styled.div`
  padding: ${
          ({padding}) => padding ? padding : "0 1rem"
  };
  margin: ${
          ({margin}) => (margin ? margin : "0 auto")
  };
  max-width: ${
          ({maxWidth, theme}) =>
                  maxWidth ? maxWidth : theme.grid.outer
  };
  display: flex;
  flex-direction: row;
  gap: 2rem;
  ${media.lessThan(breakpoints.ipad)`
        flex-direction: column;
  `
  }
`;
export const ReportFieldForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${
          ({gap}) => gap ? gap : "2rem"
  };

  textarea, input {
    padding: 12px 24px;
    border-radius: 24px;
    resize: none;
    outline: none;

    &:focus, &:hover {
      outline: none;
    }
  }

  input {
    border-radius: 100px;
    height: 50px;
  }

  .emailinput {
    max-width: 410px;
  }

  .checkboxWrapper {
    display: flex;
    align-items: center;
    outline: none;

    &:focus, &:hover {
      border: none;
      outline: none;
    }

    input, label {
      &:focus, &:hover {
        border: none;
        outline: none;
      }
    }
  }

  .checkboxStyle {
    &:checked ~ label {
      &:before {
        background-color: ${({color, theme}) =>
                color ? `${color}` : `${theme.colors.primary}`};
      }

      &:after {
        transform: rotate(-45deg) scale(1);
        border-color: ${({markerColor, theme}) =>
                markerColor ? `${markerColor}` : `${theme.colors.white}`};
      }
    }

    &:focus + label {
      outline: none;
    }
  }

  .checkBoxLabel {
    display: flex;
    align-items: center;
    padding-left: 40px;

    &:after {
      left: 9px;
    }

    &:before {
      top: 3px;
      width: 18px;
      height: 18px;
      border-color: ${({theme}) => `${theme.colors.primary}`};

    }
  }
`;
export const ReportFieldDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${
          ({gap}) => gap ? gap : "2rem"
  };
`;
export default RenderReportTechnicalUrlPage;
